import "./Intro.css"

const Intro = () =>{
    return (

        <div class="container-fluid intro">
            
            <div class="textIn">
            <h1 class="name">Hi I'm Srijan Bhardwaj</h1>
            <h4 class="line-1 anim-typewriter">An IT undergrad with interests in Competitive Programming and Web designing</h4>
            <a href="#about"><button type="button" class="intro-btn animate__animated wow animate__pulse">Explore</button></a>
            </div>
        </div>
            
    )
};

export default Intro;